import React from 'react';
import { SheetModal } from '../../../../../brenger-shared-ui/components/layout/sheetlayout/SheetModal';
import { Translate } from 'react-localize-redux-dep-updated';
import { Button } from '../../../../../brenger-shared-ui';

interface Props {
  weightCheck: boolean;
  dimensionCheck: boolean;
  isActive: boolean;
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => void;
}

export const DimensionsCheck: React.FC<Props> = ({
  weightCheck,
  dimensionCheck,
  isActive,
  onClose,
  onCancel,
  onSubmit,
}) => {
  return (
    <SheetModal isActive={isActive} closeHandler={onClose} closeByBackdrop={false} isPrompt={true}>
      {!weightCheck && dimensionCheck && (
        <>
          <div className="ps-modal--section">
            <h6>
              <Translate id={'request_flow.what.example_dimensions.title'} />
            </h6>
          </div>
          <div className="ps-modal--section">
            <Translate id={'request_flow.what.example_dimensions.description'} />
          </div>
        </>
      )}
      {weightCheck && !dimensionCheck && (
        <>
          <div className="ps-modal--section">
            <h6>
              <Translate id={'request_flow.what.example_weight.title'} />
            </h6>
          </div>
          <div className="ps-modal--section">
            <Translate id={'request_flow.what.example_weight.description'} />
          </div>
        </>
      )}
      {weightCheck && dimensionCheck && (
        <>
          <div className="ps-modal--section">
            <h6>
              <Translate id={'request_flow.what.example_dimensions_and_weight.title'} />
            </h6>
          </div>
          <div className="ps-modal--section">
            <Translate id={'request_flow.what.example_dimensions_and_weight.description'} />
          </div>
        </>
      )}
      <div className="ps-modal--section">
        <div className="flex justify-between">
          <Button
            style={{ width: '160px', marginRight: '1rem' }}
            buttonStyle="primary"
            type="button"
            onClick={onCancel}
          >
            <Translate id={'request_flow.what.example_dimensions.cancel'} />
          </Button>
          <Button onClick={onSubmit} style={{ width: '160px' }} buttonStyle="secondary" type="button">
            <Translate id={'request_flow.what.example_dimensions.submit'} />
          </Button>
        </div>
      </div>
    </SheetModal>
  );
};
